export default {
  template_id: 'gh_flex',
  html: function (value, func) {
    return `<div class="${ value.class }">${ func(value.content) }</div>`;
  }
};
